import styled from 'styled-components';
import colors from "constants/colors";

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  column-gap: 16px;

  div {
    width: 100%;

    .label {
      font-size: 12px;
      font-weight: 600;
      color: ${colors.silver};
    }

    .value {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      row-gap: 8px;
      font-size: 14px;
      font-weight: 600;
      color: ${colors.white};
      margin-top: 12px;
    }
  }
`;

export const VoucherContainer = styled.div`
  width: 100%;
  display: flex;
  column-gap: 16px;

  div {
    width: 15%;

    .label {
      font-size: 12px;
      font-weight: 600;
      color: ${colors.silver};
    }

    .value {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      row-gap: 8px;
      font-size: 14px;
      font-weight: 600;
      color: ${colors.white};
      margin-top: 12px;
    }
  }
`;

